import React, {useContext, useEffect} from "react";
import MobXContext from "../mobx/MobXContext";

export default (WrappedComponent, title) => ({...rest}) => {
	const {appStore} = useContext(MobXContext);
	useEffect(() => (appStore.pageTitle = `Utah Header - ${title}`) && undefined, []);
	return <WrappedComponent {...rest} />;
};
